/* ============================================================
   兼容平台 (Compatible Platforms) — section behaviour
   Category tabs + MULTI-SELECT platform filter + sort + compare tray/modal.

   · On load the filter defaults to Apple Home (override per section with
     data-default-platform="matter|apple|alexa|google|st" on .cp-root, or
     "" for no default). A #hash from the hero badges / footer links wins.
   · Cards list ONLY supported platforms (.cp-plat-tag--yes). Anything that
     counts "how many platforms" must count --yes.
   · Several platforms selected = AND (a product must support them all).
   · Products with no supported platform are hidden (pure accessories).
   Class/attribute toggles and textContent only; no innerHTML UI injection.
   ============================================================ */
(function () {
  'use strict';

  var PLATS = ['matter', 'apple', 'alexa', 'google', 'st'];
  var HASH_MAP = {
    'matter': 'matter', 'apple-home': 'apple', 'amazon-alexa': 'alexa',
    'google-home': 'google', 'smartthings': 'st'
  };
  var PLAT_HASH = {
    matter: 'matter', apple: 'apple-home', alexa: 'amazon-alexa',
    google: 'google-home', st: 'smartthings'
  };
  var MAX = 3;

  function init(root) {
    if (!root || root.dataset.cpReady === '1') return;
    root.dataset.cpReady = '1';

    // set data-show-untagged="1" on .cp-root to reveal products that have no
    // platform tag yet (useful for auditing which products still need tagging)
    var showUntagged = root.dataset.showUntagged === '1';
    var defaultPlatform = root.dataset.defaultPlatform;
    if (defaultPlatform === undefined) defaultPlatform = 'apple';

    var tabs = [].slice.call(root.querySelectorAll('.cp-tab'));
    var groups = [].slice.call(root.querySelectorAll('.cp-grp'));
    var platChecks = [].slice.call(root.querySelectorAll('.cp-plat-check'));
    var platTags = [].slice.call(root.querySelectorAll('.cp-plat-tag'));
    var banners = [].slice.call(root.querySelectorAll('.cp-ib'));
    var countEl = root.querySelector('.cp-count-value');
    var sortSel = root.querySelector('.cp-sort-select');
    var sortLabel = root.querySelector('.cp-sort-value');
    var picked = [];
    var sel = [];   // selected platforms; empty = no filter

    function cat() { return root.getAttribute('data-cat') || 'all'; }

    function matches(card) {
      if (!showUntagged && card.querySelectorAll('.cp-plat-tag--yes').length === 0) return false;
      for (var i = 0; i < sel.length; i++) {
        if (!card.classList.contains('cp-p-' + sel[i])) return false;
      }
      return true;
    }

    function apply() {
      var c = cat(), total = 0;
      groups.forEach(function (g) {
        var catOK = (c === 'all') || g.dataset.cat === c;
        var vis = 0;
        [].forEach.call(g.querySelectorAll('.cp-card'), function (card) {
          var ok = matches(card);
          card.classList.toggle('is-off', !ok);
          if (ok) vis++;
        });
        g.classList.toggle('is-off', !catOK || vis === 0);
        if (catOK) total += vis;
      });
      if (countEl) countEl.textContent = total;
      root.setAttribute('data-empty', total === 0 ? '1' : '0');
    }

    /* ---- Category tabs ---- */
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        root.setAttribute('data-cat', t.dataset.cat);
        tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        apply();
      });
    });

    /* ---- Platform filter (multi-select icon pills) ---- */
    function syncPlatformUI() {
      PLATS.forEach(function (p) { root.classList.toggle('pf-' + p, sel.indexOf(p) !== -1); });
      platChecks.forEach(function (c) { c.checked = sel.indexOf(c.value) !== -1; });

      // one selected -> that platform's blurb; none or several -> the overview
      var showPlat = (sel.length === 1) ? sel[0] : 'all';
      banners.forEach(function (ib) { ib.classList.toggle('is-on', ib.dataset.plat === showPlat); });

      // a chip lights up when its platform is selected
      platTags.forEach(function (tag) {
        var key = null;
        PLATS.forEach(function (p) { if (tag.classList.contains('cp-t-' + p)) key = p; });
        tag.classList.toggle('is-on', key !== null && sel.indexOf(key) !== -1);
      });
    }

    function setPlatforms(list, updateHash) {
      sel = list.slice();
      syncPlatformUI();
      if (updateHash && window.history && history.replaceState) {
        history.replaceState(null, '', sel.length === 1 ? '#' + PLAT_HASH[sel[0]] : location.pathname);
      }
      apply();
    }

    platChecks.forEach(function (c) {
      c.addEventListener('change', function () {
        setPlatforms(platChecks.filter(function (x) { return x.checked; })
                               .map(function (x) { return x.value; }), true);
      });
    });

    /* ---- Sort (CSS order within each grid) ---- */
    function sortCards(mode) {
      groups.forEach(function (g) {
        var keyed = [].slice.call(g.querySelectorAll('.cp-card')).map(function (card, i) {
          return {
            card: card, i: i,
            name: (card.querySelector('.cp-card-name') || {}).textContent || '',
            n: card.querySelectorAll('.cp-plat-tag--yes').length,
            price: parseFloat(card.dataset.price || '0')
          };
        });
        if (mode === 'most') keyed.sort(function (a, b) { return b.n - a.n || a.i - b.i; });
        else if (mode === 'price-asc') keyed.sort(function (a, b) { return a.price - b.price || a.i - b.i; });
        else if (mode === 'name') keyed.sort(function (a, b) { return a.name.trim().localeCompare(b.name.trim(), 'zh-Hant'); });
        else keyed.sort(function (a, b) { return a.i - b.i; });
        keyed.forEach(function (k, idx) { k.card.style.order = idx; });
      });
    }
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        if (sortLabel) sortLabel.textContent = sortSel.options[sortSel.selectedIndex].text;
        sortCards(sortSel.value);
      });
    }

    /* ---- Compare ---- */
    var slots = [].slice.call(root.querySelectorAll('.cp-slot'));
    var goBtn = root.querySelector('.cp-go');
    var clearBtn = root.querySelector('.cp-clear');
    var closeBtn = root.querySelector('.cp-close');
    var modal = root.querySelector('.cp-modal');
    var cmpBtns = [].slice.call(root.querySelectorAll('.cp-btn--compare'));

    function renderTray() {
      slots.forEach(function (slot, i) {
        var card = picked[i];
        var nameEl = slot.querySelector('.cp-s-name');
        if (card) {
          slot.setAttribute('data-filled', '1');
          nameEl.textContent = card.dataset.name || '';
        } else {
          slot.setAttribute('data-filled', '0');
          nameEl.textContent = '';
        }
      });
      if (goBtn) {
        goBtn.textContent = (goBtn.dataset.label || '比較') + ' (' + picked.length + ')';
        goBtn.disabled = picked.length < 2;
      }
      root.setAttribute('data-tray', picked.length ? '1' : '0');
      cmpBtns.forEach(function (b) {
        var card = b.closest('.cp-card');
        var on = picked.indexOf(card) !== -1;
        b.setAttribute('data-picked', on ? '1' : '0');
        b.textContent = on ? (b.dataset.labelOn || '已加入') : (b.dataset.labelOff || '比較');
        b.disabled = !on && picked.length >= MAX;
      });
    }

    cmpBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = b.closest('.cp-card');
        var i = picked.indexOf(card);
        if (i !== -1) picked.splice(i, 1);
        else if (picked.length < MAX) picked.push(card);
        renderTray();
      });
    });
    slots.forEach(function (slot, i) {
      var x = slot.querySelector('.cp-x');
      if (x) x.addEventListener('click', function () { picked.splice(i, 1); renderTray(); });
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { picked = []; renderTray(); });

    function openCompare() {
      [1, 2, 3].forEach(function (n) {
        var col = root.querySelector('.cp-col[data-col="' + n + '"]');
        var card = picked[n - 1];
        if (!col) return;
        if (!card) { col.setAttribute('data-filled', '0'); return; }
        col.setAttribute('data-filled', '1');
        col.querySelector('[data-f="name"]').textContent = card.dataset.name || '';
        var connCell = col.querySelector('[data-f="conn"]');
        if (connCell) connCell.textContent = card.dataset.conn || '—';
        PLATS.forEach(function (p) {
          var cell = col.querySelector('[data-f="' + p + '"]');
          if (!cell) return;
          var tag = card.querySelector('.cp-plat-tag--yes.cp-t-' + p);
          var yes = card.classList.contains('cp-p-' + p);
          cell.textContent = yes ? (tag && tag.textContent.indexOf('＊') !== -1 ? '✓＊' : '✓') : '—';
          cell.className = 'cp-cell ' + (yes ? 'cp-yes' : 'cp-no');
        });
      });
      root.setAttribute('data-modal', '1');
    }
    if (goBtn) goBtn.addEventListener('click', openCompare);
    if (closeBtn) closeBtn.addEventListener('click', function () { root.setAttribute('data-modal', '0'); });
    if (modal) modal.addEventListener('click', function (e) {
      if (e.target === modal) root.setAttribute('data-modal', '0');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') root.setAttribute('data-modal', '0');
    });

    /* ---- Hash -> platform (hero badges + footer links) ---- */
    var appliedFromHash = false;
    function fromHash(scroll) {
      var h = location.hash.replace('#', '');
      if (HASH_MAP[h]) {
        setPlatforms([HASH_MAP[h]], false);
        appliedFromHash = true;
        if (scroll) {
          var el = root.querySelector('.cp-tabbar-wrap');
          if (el) el.scrollIntoView();
        }
      }
    }
    window.addEventListener('hashchange', function () { fromHash(true); });

    fromHash(false);
    if (!appliedFromHash && defaultPlatform) setPlatforms([defaultPlatform], false);
    renderTray();
    syncPlatformUI();
    apply();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('.cp-root'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.cp-root');
    if (r) { r.dataset.cpReady = '0'; init(r); }
  });
})();
